import { useI18nContext } from '../localization/i18n-react';

export function useLocalization() {
  const { LL: translations, ...rest } = useI18nContext();

  return { translations, ...rest };
}
